import RatingStars from "@/components/base/RatingStars";
import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/siteContent";

export default function Testimonials() {
  return (
    <section className="mx-auto w-full max-w-[1400px] px-6 py-16 md:py-20">
      <SectionHeading
        eyebrow="Loved by the coast"
        title="What business owners and customers say"
        description="Real feedback from businesses growing their reach and customers who found exactly what they needed."
      />

      <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {testimonials.map((item) => (
          <article
            key={item.id}
            className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className="ri-double-quotes-l text-lg" />
            </span>
            <RatingStars rating={item.rating} showValue={false} />
            <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">"{item.quote}"</p>
            <div className="mt-5 border-t border-background-200 pt-4">
              <p className="font-heading text-sm font-bold text-foreground-950">{item.name}</p>
              <p className="mt-0.5 text-xs text-foreground-500">{item.role}</p>
              <p className="mt-1 flex items-center gap-1.5 text-xs font-medium text-secondary-700">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-map-pin-line text-[13px]" />
                </span>
                {item.location}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}